import translation from 'translation';

function getDefaultDetailedMetricsList () {
  return [
    {
      id: 'clicks',
      simple_id: 'clicks',
      group: translation.tr('Channel statistics'),
      name: translation.tr('Clicks'),
      type: 'integer'
    },
    {
      id: 'impressions',
      simple_id: 'impressions',
      group: translation.tr('Channel statistics'),
      name: translation.tr('Impressions'),
      type: 'integer'
    }
  ];
}

export default getDefaultDetailedMetricsList;
